import React from 'react';
import styles from './Badge.module.css';

const COLOR_MAP = {
  pending: 'yellow',
  draft: 'gray',
  submitted: 'yellow',
  changes_requested: 'orange',
  approved: 'green',
  rejected: 'red',
  suspended: 'orange',
  active: 'green',
  inactive: 'red',
  true: 'green',
  false: 'red',
  admin: 'purple',
  vehicle_owner: 'blue',
  private_person: 'teal',
  insurance_agency: 'orange',
  path_a: 'blue',
  path_b: 'orange',
  not_started: 'gray',
  enabled: 'green',
  blocked: 'red',
  private_individual: 'teal',
  company_fleet: 'purple',
};

export default function Badge({ value, label }) {
  const key = String(value).toLowerCase();
  const color = COLOR_MAP[key] || 'gray';
  return (
    <span className={`${styles.badge} ${styles[color]}`}>
      {label || value}
    </span>
  );
}
